module.exports = __webpack_public_path__ + "img/insurance-cost.f5ea8341.svg";